module.exports = __webpack_public_path__ + "img/placeholder.9d0c0524.png";